import { gateway } from '../../../gateway';
import { KanbanPage } from "../interfaces/kanbanPage.interface";

/**
 * Action to create a new kanban page
 *
 * Backend endpoint: POST /kanban-pages/self
 * Request body: { name: string, description?: string, order?: number }
 * Response format: { status: 201, message: "Kanban page created", data: KanbanPage }
 */
export const createKanbanPageAction = async (name: string): Promise<KanbanPage> => {
  try {
    const trimmedName = name.trim();
    
    if (!trimmedName) {
      throw new Error('Page name is required');
    }

    const response = await gateway.post('/kanban-pages/self', {
      name: trimmedName,
    });

    // Backend returns { status, message, data } where data is the created page
    const page = response.data?.data || response.data;
    
    if (!page) {
      throw new Error('Invalid response from server');
    }

    return page;
  } catch (error: any) {
    console.error('Error creating kanban page:', error);
    // Extract error message from backend response
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to create kanban page';
    throw new Error(errorMessage);
  }
};
